import styled, { css } from "styled-components";
import { useSelector } from "react-redux";
import ScrollAnimation from "react-animate-on-scroll";

import { scrollAnimationProps as animationProps } from "globalConstants";

import * as Types from "Types";
import * as grid from "grid";

import AtomDescription1 from "Components/Atoms/Description1";

const Wrap = styled.div<Types.Default>`
   & .animated {
      transition-duration: 1s;
      transition-property: opacity;
      transition-timing-function: ease-in-out;
      opacity: 0;
   }
   & .scrollAnimation {
      opacity: 1;
   }
   ${({ css }) => css}
`;

const XSWrap = styled.div<Types.Default>`
   padding: 0 17px;
`;

const Text = styled(AtomDescription1)<Types.Default>`
   margin-top: 30px;
   line-height: 31px;
   ${({ css }) => css}
`;
const XSText = styled(AtomDescription1)<Types.Default>`
   margin-top: 30px;
   line-height: 31px;
   ${({ css }) => css}
`;

export default function Content2(props: Types.Default) {
   const windowWidth = useSelector(({ dimensions }: Types.State) => dimensions.width);
   const shows = grid.shows({
      width: windowWidth,
      grids: { xs: false },
   });
   return (
      <Wrap {...props}>
         {shows ? (
            <>
               <ScrollAnimation {...animationProps}>
                  <Text
                     css={css`
                        margin-top: 60px;
                     `}>
                     <p>아트맵은 미술시장의 폐쇄성을 타파하고, 미술을 확산시키기 위해 각 분야의 전문가들이 모여 창립했습니다.</p>
                     <p>데이터베이스 전문가, 소프트웨어 개발자, 전업 작가, 큐레이터, 기획자, 디자이너 등</p>
                     <p>각 분야에서 우수한 능력을 발휘하고 있는 이들이 함께 합니다.</p>
                  </Text>
               </ScrollAnimation>
               <ScrollAnimation {...animationProps}>
                  <Text>
                     <p>어플리케이션과 웹페이지를 필두로 한 11만 명 이상의 회원,</p>
                     <p>Art content Provider로 다가가기 위해 8채널을 보유한 유일한 아트 큐레이션 플랫폼으로</p>
                     <p>미술시장의 분석과 취향데이터의 구축으로 문화, 미술계에 신임을 줄 수 있는</p>
                     <p>다양한 상품을 제공 중이며 아트플랫폼의 퍼스트 무버를 목표하고 있습니다.</p>
                  </Text>
               </ScrollAnimation>
               <ScrollAnimation {...animationProps}>
                  <Text>
                     <p>아트맵에는 매일 실시간으로 새로운 작품, 전시회가 등록됩니다.</p>
                     <p>작품 및 전시회 선호도, 미술 취향에 대한 메타데이터를 구축해</p>
                     <p>작가·전시관·관람객 3주체가 모두 만족하는 서비스를 제공합니다.</p>
                  </Text>
               </ScrollAnimation>
            </>
         ) : (
            <XSWrap>
               <ScrollAnimation {...animationProps}>
                  <XSText>
                     아트맵은 미술시장의 폐쇄성을 타파하고, 미술을 확산시키기 위해 각 분야의 전문가들이 모여 창립했습니다. 데이터베이스 전문가, 소프트웨어 개발자, 전업 작가, 큐레이터, 기획자, 디자이너
                     등 각 분야에서 우수한 능력을 발휘하고 있는 이들이 함께 합니다.
                  </XSText>
               </ScrollAnimation>
               <ScrollAnimation {...animationProps}>
                  <XSText>
                     어플리케이션과 웹페이지를 필두로 한 11만 명 이상의 회원, Art content Provider로 다가가기 위해 8채널을 보유한 유일한 아트 큐레이션 플랫폼으로 미술시장의 분석과 취향데이터의
                     구축으로 문화, 미술계에 신임을 줄 수 있는 다양한 상품을 제공 중이며 아트플랫폼의 퍼스트 무버를 목표하고 있습니다.
                  </XSText>
               </ScrollAnimation>
               <ScrollAnimation {...animationProps}>
                  <XSText>아트맵에는 매일 실시간으로 새로운 작품, 전시회가 등록됩니다.</XSText>
               </ScrollAnimation>
               <ScrollAnimation {...animationProps}>
                  <XSText>작품 및 전시회 선호도, 미술 취향에 대한 메타데이터를 구축해 작가·전시관·관람객 3주체가 모두 만족하는 서비스를 제공합니다.</XSText>
               </ScrollAnimation>
            </XSWrap>
         )}
      </Wrap>
   );
}
